/**
 * Returns a BreadcrumbList schema for the given category.
 * The schema includes a link to the home page, followed by each
 * breadcrumb in the category's breadcrumbs array.
 *
 * @param {Object} cat - The category object for which to generate
 *   the schema.
 * @returns {Object} The schema as a JSON string, with the
 *   `__html` property.
 */
export const breadsCrumbSchema = (cat) => {
  let arr = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.orientbell.com",
    },
  ];

  for (let i = 0; i < cat.breadcrumbs.length; i++) {
    arr.push({
      "@type": "ListItem",
      position: i + 2,
      name: cat.breadcrumbs[i].category_name,
      item: `https://www.orientbell.com/${cat.breadcrumbs[i].category_url_path}`,
    });
  }

  return {
    __html: JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: arr,
    }),
  };
};
/**
 * Generates a structured data script for a webpage using Schema.org markup.
 *
 * @param {Object} data - The data object containing product and category information.
 * @param {Object} router - The router object providing the current path information.
 * @returns {Object} An object with an __html property containing the JSON-LD script
 * for the webpage's schema, including context, type, URL, headline, breadcrumb,
 * name, and description.
 */

export const webPageSchema = (data, router) => {
  return {
    __html: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "${router.asPath}",
        "headline": "",
        "breadcrumb": "Home > Tiles > ${
          data.products.currentcategory?.breadcrumbs
            ? data.products.currentcategory?.breadcrumbs[1]?.category_name
            : ""
        }",
        "name": "${data.products?.currentcategory?.meta_title}",
        "description": "${data.products?.currentcategory?.meta_description}"
      }`,
  };
};
